import { render, staticRenderFns } from "./HistoryRecord.vue?vue&type=template&id=d3db4968&scoped=true"
import script from "./HistoryRecord.vue?vue&type=script&lang=js"
export * from "./HistoryRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@5.2.7_vue-template-compiler@2.6.14_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3db4968",
  null
  
)

export default component.exports